import { globalHistory as history } from '@reach/router';
import BottomNavigation from 'components/Universal/BottomNavigation';
import CookiePolicy from 'components/Universal/CookiePolicy';
import Header from 'components/Universal/Header';
import { routes } from 'constants/routes';
import HeaderContext from 'providers/HeaderProvider';
import React, { useContext, useState } from 'react';
import {  useGesture } from 'react-use-gesture';
import { NAV } from 'constants/enums';

export const DIRECTION = { BOTTOM: 0, TOP: 1};

export default function AppMobile({ isPortrait, children }) {
	const { location, navigate } = history;
	const { header, isFixedHide } = useContext(HeaderContext);

	const [index, setIndex] = useState(NAV.NOT_VISIBLE);
	const [isOpenMenu, setOpenMenu] = useState(false);
	const [isOpenFromHeader, setOpenFromHeader] = useState(false);
	const [direction, setDirection] = useState(null);

	const bind = useGesture({
		onDragStart: () => handleDragStart()
	});

	const handleDragStart = () => {
		setOpenMenu(false);
	};

	const handleToggleMenu = isOpenFromHeader => () => {
		setDirection(isOpenFromHeader ? DIRECTION.TOP : DIRECTION.BOTTOM);
		setOpenMenu(prev => !prev);

		if(isOpenMenu) {
			// TODO: from bottom to top animation
			if(isOpenFromHeader && direction === DIRECTION.BOTTOM) {
				setOpenFromHeader(isOpenFromHeader);
				setIndex(NAV.MENU);
				setOpenMenu(true);
			} else if(!isOpenFromHeader && direction === DIRECTION.TOP) {
				// TODO: from top to bottom animation
				setOpenFromHeader(isOpenFromHeader);
				setIndex(NAV.MENU);
				setOpenMenu(true);
			} else {
				switch(location.pathname) {
					case routes.ACADEMY: setIndex(NAV.ACADEMY); break;
					case routes.PRODUCTS: setIndex(NAV.PRODUCTS); break;
					case routes.CONTACT: setIndex(NAV.CONTACT); break;
					default: console.log('unhandled::AppMobile::handleToggleMenu'); setIndex(NAV.NOT_VISIBLE); break;
				}
			}
		} else {
			setOpenFromHeader(isOpenFromHeader);
			setIndex(NAV.MENU);
		}
	};

	const handleRedirectFromMenu = route => {
		setOpenMenu(false);

		switch(route) {
			case routes.ACADEMY: setIndex(NAV.ACADEMY); break;
			case routes.PRODUCTS: setIndex(NAV.PRODUCTS); break;
			case routes.CONTACT: setIndex(NAV.CONTACT); break;
			default: break;
		}
	};

	const handleNav = (route, index) => () => {
		setIndex(index);
		navigate(route);
		setOpenMenu(false);
	};

	return (
		<div>
			{isPortrait && (
				<Header
					onClickMenu={handleToggleMenu(true)}
					type={header.type}
					title={header.title}
					withIconMain={header.isMain}
					withIconSelect={header.isSelect}
					withIconLimit={header.isLimit}
					isSelectProduct={header.isSelectProduct}
					isLimitProduct={header.isLimitProduct}
				/>
			)}

			<div {...bind()} className='container bg-light'>
				{children}
			</div>

			{isPortrait && !isFixedHide && (
				<BottomNavigation
					index={index}
					direction={direction}
					isOpenMenu={isOpenMenu}
					isOpenFromHeader={isOpenFromHeader}
					onClickMenu={handleToggleMenu(false)}
					onClickAcademy={handleNav(routes.ACADEMY, NAV.ACADEMY)}
					onClickProducts={handleNav(routes.PRODUCTS, NAV.PRODUCTS)}
					onClickContact={handleNav(routes.CONTACT, NAV.CONTACT)}
					onRedirectFromMenu={handleRedirectFromMenu}
				/>
			)}

			<CookiePolicy />
		</div>
	);
}
